const user = state => state.user;
const error = state => state.error;
const status = state => state.status;
const isLoading = state => state.isLoading;

export default {
  user,
  status,
  error,
  isLoading
};